import { createApp, defineAsyncComponent } from "vue";

import SvgVue from 'svg-vue3'
import VueLazyLoad from 'vue3-lazyload'

const app = createApp({
  components: {
    VideoBackground: defineAsyncComponent(() => import('./common/VideoBackground.vue')),
    Slider: defineAsyncComponent(() => import('./common/Slider.vue')),
    SocialIcons: defineAsyncComponent(() => import('./common/SocialMediaIcons.vue')),
    ClientSlider: defineAsyncComponent(() => import('./common/ClientSlider.vue')),
    ReviewSlider: defineAsyncComponent(() => import('./common/ReviewSlider.vue')),
  },

  data: () => ({
    openMenu: '',
    scrollPosition: 0,
    activeService: 1,
    activeMobileNavGroup: 1,
  }),

  computed: {
    mobileMenu () {
      return this.openMenu === 'mobileMenu'
    },
    isScrolling () {
      return this.scrollPosition > 0
    },
  },

  methods: {
    toggleMenu (menu) {
      this.openMenu = (this.openMenu != menu ? menu : '')
    },
    setMobileNavGroup (item) {
      this.activeMobileNavGroup = this.activeMobileNavGroup != item ? item : ''
    },
    handleScroll (event) {
      this.scrollPosition = window.pageYOffset != undefined ? window.pageYOffset : window.scrollY
    },
    setSidebar (sidebar) {
      this.openSidebar = sidebar
    },
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

})

app.use(VueLazyLoad)
app.use(SvgVue, {
  svgPath: 'resources/svg',
  extract: false,
  svgoSettings: [
      { removeTitle: true },
      { removeViewBox: false },
      { removeDimensions: true }
  ]
})

app.mount("#app")
